import React, { useContext, useEffect } from 'react';
// import { initReactI18next, useTranslation } from 'react-i18next';
import { videoPlayerIcon } from '../../../images/images';
// import languageEN from '../../../locate/en/translate.json'
// import languageHN from '../../../locate/hn/translate.json'
import { playVoiceOver } from '../../../utils/handleVoiceAndLang';
import LanguageTranslater from '../../HOC/LanguageTranslater';
import './ConsentInstruction.css'
import { SpeakerContext } from '../../../context/SpeakerContext';

const ConsentInstruction = ({ hideConsentInstructions, translate }) => {
  const { isVoiceOverDisable } = useContext(SpeakerContext)
  //   const { t, i18n } = useTranslation();
  // const resources = {
  //   eng: { translation: languageEN },
  //   hin: { translation: languageHN },
  // };
  useEffect(() => {
    // i18n.use(initReactI18next).init({
    //   resources,
    //   lng: localStorage.getItem("LanguageSelected"),
    //   // lng: "eng",

    //   /* default language when load the website in browser */

    //   keySeparator: false,
    //   // debug: true,
    //   interpolation: {
    //     escapeValue: false,
    //   },
    // });
    if(!isVoiceOverDisable){
      playVoiceOver('ci-aud', 'consent')
    }
  }, []);
  return (
    <div className='consent-instruction-cntnr' >
      <div className='consent-instructions' >
        <div className='video-instruction' >
          <div className='ins-txt' >
            <h2>{translate("consent_ins_heading")}</h2>
            <p>
              {translate("consent_ins_1")}
            </p>
          </div>
          <div className='ins-icon' >
            <img src={videoPlayerIcon} height="30px" width="50px" alt='' />
          </div>
        </div>
        <div className='recording-instruction' >
          <div className='ins-txt' >
            <h2>{translate("how_to_record")}</h2>
            <p>
              {translate("record_ins")}
            </p>
            <p className='done-ins' >
              {translate("done_ins")}
            </p>
          </div>
        </div>
      </div>
      <div className='recording-btns ci-btn' >
        <button onClick={hideConsentInstructions}>{translate("start_verification")}</button>
      </div>
    </div>
  );
}

export default LanguageTranslater(ConsentInstruction);